// extracted by mini-css-extract-plugin
export default {"homologacaoBotoes":"ArquivarAnaliseProjeto_homologacaoBotoes__VaKlH","motivoArquivamento":"ArquivarAnaliseProjeto_motivoArquivamento__oIGL6"};